import React from 'react'

export default function AutoPayBanner({ promoImg, onClick, loading = false, mx = 16, mt = 16, height = 116 }) {
  const showSkeleton = loading && !promoImg
  if (!loading && !promoImg) return null

  return (
    <div
      className={`traffic-fine-autopay-banner ${showSkeleton ? 'is-skeleton' : ''}`}
      style={{ marginLeft: mx, marginRight: mx, marginTop: mt }}
      onClick={() => {
        if (showSkeleton) return
        onClick?.()
      }}>
      <div className="traffic-fine-autopay-banner-inner" style={{ height }}>
        {showSkeleton ? <div className="traffic-fine-skeleton-block" /> : <img src={promoImg} alt="promo banner" loading="lazy" decoding="async" />}
      </div>
    </div>
  )
}
